module.exports = __webpack_public_path__ + "static/media/LOGO_HDM_2.40367069.svg";